var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h3',[_vm._v(_vm._s(_vm.$t("navigation." + _vm.ROUTE_LOGIN)))]),_c('UserForm',{on:{"userSubmitted":_vm.login}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }